export const SERVICES = [{ service: 'matomo', label: 'Matomo' }]

export const SERVICE_MATOMO = SERVICES[0]
